module.exports = __webpack_public_path__ + "images/company/covid19/top_image@2x_d47389441f233ffd71866dc51225561f.png";